import { Avatar, Flex } from '@chakra-ui/react'
import { Container, EndIcon, ColumnText } from './styles'
import { FaEdit, FaRegCheckCircle, FaRegTimesCircle } from 'react-icons/fa'
import { iAvaliador } from '../../../../../interfaces'

interface iCardProps {
  tipo: number
  avaliador: iAvaliador
  encerrada: boolean
  isFromCalibracao?: boolean
  onEdit: (avaliador: iAvaliador) => void
}

export const CardAssociado: React.FC<iCardProps> = ({ avaliador, tipo, onEdit, encerrada, isFromCalibracao }) => {
  function ObterTipo(type: number): string {
    switch (type) {
      case 1:
        return 'Gestor'

      case 2:
        return 'Par'

      case 3:
        return 'Liderados'

      case 4:
        return 'Outros'

      case 6:
        return 'Alta liderança'

      default:
        return 'null'
    }
  }
  return (
    <Container respondido={avaliador.respondido}>
      <Flex alignItems={'center'} p={'.5rem .125rem .5rem 1.25rem'} pos={'relative'}>
        <Flex alignItems={'center'} pos={'absolute'} top={'4px'} left={'4px'} fontSize={'14px'}>
          {avaliador.respondido ? <FaRegCheckCircle color='var(--Green2)' /> : <FaRegTimesCircle color='var(--Red)'/>}
        </Flex>
        <Avatar size={'sm'} name={avaliador.nome} src={avaliador.avatar} />
        <ColumnText>
          {
            avaliador.nome && avaliador.nome?.length > 21
              ? <span title={avaliador.nome}>{avaliador.nome.substring(0, 22)}...</span>
              : <span>{avaliador.nome}</span>
          }
          <strong style={{ lineHeight: '.85rem', fontSize: '.813rem' }}>{ObterTipo(tipo)}</strong>
          <span>{ }</span>
        </ColumnText>
      </Flex>
      {!isFromCalibracao && !encerrada && <EndIcon>
        <FaEdit size={14} onClick={() => onEdit(avaliador)}/>
      </EndIcon>}
    </Container >
  )
}
